export default "__VITE_ASSET__28b3bbe9__"